import { useEffect } from 'react'
import { useNavigate } from 'react-router';
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import { t } from "i18next";

import { setTemporaryNotifications } from 'redux/notifications/actions';
import { defaultNotificationCreator } from 'templates/Notifications';
import { mustCatchPostMessage } from 'utils/iframeHelper'
import {
    setCurrentOrderId,
    setIsOrdersSettingsFormOpen,
    setIsOrderFormModalOpen,
    setStickerOrderId,
    setOrderExtId,
    setMarketId
} from "../../redux/orders/reducer";
import {currentSellerId} from "../../constants/storageKeys";

const PostMessageCatcher = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const entityTitle = {
          entity: "document-title",
          action: "change"
        }
    
        const entityPathname = {
          entity: "document-pathname",
          action: "change"
        }
    
        const redirectToHome = {
          entity: "homePage",
          action: "open"
        }
    
        const redirectToLogin = {
          entity: "loginPage",
          action: "open"
        }
    
        const notificationMessage = {
          entity: "flashMessage",
          action: "set"
        }

        const feedModal = {
          entity: "feedModal",
          action: "open"
        }

        const orderFormModal = {
            entity: "orderFormModal",
            action: "open"
        }

        const barcodeGeneratorPage = {
            entity: "barcodeGeneratorPage",
            action: "open"
        }

        const ordersSettingsForm = {
            entity: "ordersSettingsForm",
            action: "open"
        }

        const messageHandler = function (e: MessageEvent) {
          // if(e.origin !== "https://lk.market") {
          //     return;
          // }
    
          if(!e.data.hasOwnProperty("entity")) {
            return;
          }
    
          if(mustCatchPostMessage(notificationMessage, e.data)) {
            return dispatch(setTemporaryNotifications(
              defaultNotificationCreator({
                  title: `${t("Message")}`,
                  description: `${e.data.message}`,
                  iconType: e.data.type
              })
            ))
          }
    
          if(mustCatchPostMessage(entityTitle, e.data)) {
            return document.title = e.data.data
          }
    
          if(mustCatchPostMessage(redirectToHome, e.data)) {
            return navigate(`/`);
          }
    
          if(mustCatchPostMessage(redirectToLogin, e.data)) {
            return window.location.href = `${process.env.REACT_APP_AUTH_APP_LOGIN_URL}`
          }
    
          if(mustCatchPostMessage(entityPathname, e.data)) {
            const path = window.location.pathname.replace('/a', '') + window.location.search;
            const url = new URL(`https://lk.market/a${e.data.data.path}`);
            url.searchParams.delete('_locale');
            url.searchParams.delete('_spa_auth');
            url.searchParams.delete('_spa_scope');
            const finalPath = url.pathname + url.search;
            if (path !== finalPath) {
              return window.history.replaceState(null, "", finalPath)
            }
          }

          if(mustCatchPostMessage(feedModal, e.data)) {
            dispatch({
              type: "SET_FORM_MODAL_FEED_OPEN",
              payload: true
            })
          }

          if(mustCatchPostMessage(orderFormModal, e.data)) {
              dispatch(setIsOrderFormModalOpen(true))
              dispatch(setCurrentOrderId(e.data.data.orderId))
              dispatch(setStickerOrderId(e.data.data.orderId))
              dispatch(setOrderExtId(e.data.data.orderExtId))
              dispatch(setMarketId(e.data.data.marketId))
          }

            if (mustCatchPostMessage(barcodeGeneratorPage, e.data)) {
                let sellerIdFromStorage = localStorage.getItem(currentSellerId);
                let protocol = window.location.protocol;
                let host = window.location.host;
                const url = new URL(`${protocol}//${host}/a/${sellerIdFromStorage}/tools/barcode`);
                return window.open(`${url}`, '_blank');
            }


            if(mustCatchPostMessage(ordersSettingsForm, e.data)) {
                dispatch(setIsOrdersSettingsFormOpen(true))
            }


        }
    
      window.addEventListener("message", messageHandler);
      return () => window.removeEventListener("message", messageHandler);
      }, [])

    return null;
}

export default PostMessageCatcher